import { AbstractControl, ValidationErrors } from '@angular/forms';
import { DailyBusinessHour } from '../models/callback-on-callnote.model';
import { isBusinessHour, isDayInPast, isTimeInPast } from '../helpers/date-time.helper';

export class CustomValidator {
	public static dateTimeValidator(orderedDailyBusinessHours: (null | DailyBusinessHour)[]) {
		return (control: AbstractControl): ValidationErrors | null => {
			const dateCtrl = control.get('date');
			const timeCtrl = control.get('time');

			const date = dateCtrl?.value;
			const time = timeCtrl?.value;
			const selectedDay = date?.getDay();

			let error: ValidationErrors | null = null;

			if (!time) {
				error = { timeRequired: true };
				timeCtrl?.setErrors(error);
				return error;
			}

			if (dateCtrl?.hasError('matDatepickerParse')) {
				error = { matDatepickerParse: true };
				dateCtrl?.setErrors(error);
				return error;
			}

			if (!date) {
				error = { dateRequired: true };
				dateCtrl?.setErrors(error);
				return error;
			}

			if (isDayInPast(date)) {
				error = { dayInPast: true };
				dateCtrl?.setErrors(error);
				return error;
			}

			if (isTimeInPast(date, time)) {
				error = { timeInPast: true };
				timeCtrl?.setErrors(error);
				return error;
			}

			/** Cannot select a day that is not a business day */
			if (!orderedDailyBusinessHours[selectedDay]) {
				error = { notBusinessDay: true };
				dateCtrl?.setErrors(error);
				return error;
			}

			/** Cannot select a time that is not a business hour */
			if (!isBusinessHour(time, orderedDailyBusinessHours[selectedDay])) {
				error = { notBusinessHour: true };
				timeCtrl?.setErrors(error);
				return error;
			}

			dateCtrl?.setErrors(null);
			timeCtrl?.setErrors(null);

			return null;
		};
	}
}
